import {
  CellWrapper,
  DisabledTag
} from '@nile/mangifera/src/Pebbles/TicketContainer';
import { Avatar, Link } from '@superops/ui-design-system';
import React, { useContext } from 'react';
import { isAuthorised, AppContext } from '@nile/components';

function AvatarTextCell(props) {
  const { cell, action } = props;
  const { value, column, row } = cell;
  const meta = row?.original;
  const { actions, permission } = column;
  const allProps = {
    ...cell,
    id: cell?.row?.original?.accountId,
    name: value
  };
  const appContext = useContext(AppContext);
  const { user } = appContext;
  const reference = user?.role?.roleFeatureList || [];
  const isEditAuthorised = isAuthorised(reference, permission);
  /* revisit dangerouslySetInnerHTML xss  */
  return value ? (
    <CellWrapper>
      {cell?.column?.isTrashView ? (
        <div className="ellipsis">{value}</div>
      ) : (
        <div className="fx  actr">
          <div className="mr10">
            <Avatar
              initials={value.slice(0, 1).toUpperCase()}
              name={value}
              size="extraSmall"
            />
          </div>
          {isEditAuthorised ? (
            <Link
              removeUnderline
              onClick={
                actions?.onClick?.bind(this, allProps) ||
                actions.edit.bind(this, meta)
              }
            >
              <div className="ellipsis">{value}</div>
            </Link>
          ) : (
            <div className="ellipsis" title={value}>
              {value}
            </div>
          )}
        </div>
      )}
    </CellWrapper>
  ) : (
    <DisabledTag>NA</DisabledTag>
  );
}

export default AvatarTextCell;
